import { useState, useEffect, useCallback } from 'react';
import api from '../httpClient';
import Marker from '../Marker';
import {
  APIProvider,
  Map,
} from "@vis.gl/react-google-maps";
import { socket } from '../socket';


const MapPage = () => {
  const [data, setData] = useState(null);   // Changed from useState([{}]); for socket part
  const [openInfoWindowId, setOpenInfoWindowId] = useState(null);
  const [ignoreMapClick, setIgnoreMapClick] = useState(false);

  // Gather device data
  useEffect(() => {
    // Fetch all devices at load
    const fetchDevices = async () => {
      try {
      const res = await api.get("/device-map");
        setData(res.data);
        // console.log("res.data", res.data);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    }  
    fetchDevices();

    // Set up socket for persistant data refresh
    socket.connect();
    socket.on("connect_error", (err) => {
      console.log(`Socket Connection Error: ${err.message}`);
    })
    socket.on('device_update', (update) => {
      console.log("Received update via socket", update);
      setData((prevData) => {
        if (!prevData) return prevData;
        const updatedDevices = prevData.devices.map((device) => {
          if (device.devId === update.device_id) {
            return {
              ...device,
              status: update.payload
            };
          }
          return device;
        });
        return {
          ...prevData,
          devices: updatedDevices
        }
      });
    });
    return () => socket.disconnect();
  }, []);

  // Close info window on external map click
  const handleMapClick = useCallback(() => {
    if (!ignoreMapClick) {
      setOpenInfoWindowId(null);
    }
    setIgnoreMapClick(false);
  }, [ignoreMapClick]);

  // Handle marker click from child components
  const handleMarkerClick = useCallback((pointId) => {
    setIgnoreMapClick(true);
    setOpenInfoWindowId(current => current === pointId ? null : pointId);
  }, []);

  const handleCloseInfoWindow = useCallback(() => {
    setOpenInfoWindowId(null);
  }, []);

  // Map configuration variables
  const api_key = process.env.REACT_APP_MAPS_API_KEY;
  const defaultMap = '830c412caf4cbf79';
  const aubergineMap = '1a3de3b04bbcad29';
  const map_id = defaultMap;

  if (!data || !data.lat || !data.lng) {
    return <div>Loading map data...</div>
  }

  return (
    <APIProvider apiKey={api_key}>
      <div className='map-container'>
        <Map
          defaultZoom={14} // Use logic here to set dynamically
          defaultCenter={{ lat: parseFloat(data.lat), lng: parseFloat(data.lng) }}
          mapId={map_id}
          gestureHandling={'greedy'}
          disableDefaultUI={false}
          onClick={handleMapClick}
        >
          {data.devices.map((point, index) => (
            <Marker 
              key={point.devId || index}
              point={point}
              isInfoWindowOpen={openInfoWindowId === point.devId}
              onMarkerClick={() => handleMarkerClick(point.devId)}
              onCloseInfoWindow={handleCloseInfoWindow}
            />
          )
          )}
        </Map>
      </div>
    </APIProvider>
  )
}

export default MapPage